import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { api } from "../components/Constants";
export const fetchCartitemslice = createAsyncThunk(
  "cartitems/fetchcartitems",
  async ({ userids }, thunkAPI) => {
    try {
      const response = await axios.post(api + "list_cart", {
        dealer_id: userids,
      });

      if (response.status === 200) {
        return {
          products: response.data.products || [],
        };
      }
    } catch (error) {
      console.log("Cart API error:", error);
      return thunkAPI.rejectWithValue("Failed to fetch cart items");
    }
  }
);



const initialState = {
  error: null,
  loading: false,
  status: "idle",
  cartItems: [],
};

const fetchCart = createSlice({
  name: "fetchcart",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCartitemslice.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(fetchCartitemslice.fulfilled, (state, action) => {
        state.loading = false;
        state.cartItems = action.payload.products;
        state.status = "succeeded";
      })
      .addCase(fetchCartitemslice.rejected, (state, action) => {
        state.loading = false;
        state.status = "rejected";
        state.error = action.payload || "Error occurred";
      });
  },
});

export default fetchCart.reducer;
